<template lang="pug">
  div.e-select-nested-list
    .checkbox-tree
      e-perfect-scrollbar(
      ref="scroll"
      )
        div.checkbox-tree__wrapper
          e-select-nested-list-item(
          :items="trees.nestedTree"
          :onCreateExpandToLvl="onCreateExpandToLvl"
          :valuesModel="valuesModel"
          :disabled="disabled"
          @change="$emit('change', $event)"
          @collapse="onCollapse"
          @expand="onExpand"
          )
</template>

<script>
  import ESelectNestedListItem from "./select-nested-list-item";

  const ListItem = () => ({
    id: '',
    parentId: null,
    name: '',
    childs: [],
    path: [],
    deep: 0,
    childsIdArr: [],
    isPartialSelect: false,
    isAllSelected: false,
    hasChilds: false
  })

  export default {
    name: 'e-select-nested-list',
    components: {ESelectNestedListItem},
    data () {
      return {
        error: null,
        valuesModel: {
          vals: []
        }
      }
    },
    props: {
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // (Array)
      options: null,
      optionValueKey: {
        type: String,
        default: 'id'
      },
      optionTextKey: {
        type: String,
        default: 'name'
      },
      optionTextFunc: {
        type: Function,
        default: (name, deep, child) => name
      },
      optionParentKey: {
        type: String,
        default: 'parentguid'
      },
      childsKey: {
        type: String,
        default: 'childs'
      },
      onCreateExpandToLvl: {
        type: Number,
        default: 1
      },
      adapter: {
        type: Function,
        default: (tree) => tree
      }
    },
    computed: {
      buildedTree () {
        const adapted = this.adapter(this.options)
        return this.buildTree(
          adapted,
          {
            tKey: this.optionTextKey,
            vKey: this.optionValueKey,
            cKey: this.childsKey,
            pKey: this.optionParentKey
          }
        )
      },
      trees () {
        const t0 = performance.now()
        let vals = this.valuesModel.vals
        let {nestedTree, treeIndex} = this.buildedTree
        treeIndex = this.setSelectionFlags(vals, treeIndex)
        console.log('trees', performance.now() - t0, nestedTree)
        return {nestedTree, treeIndex}
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
      this.$watch(`model.${this.name}`, (v) => {
        this.convertValuesToInnerFormat(v)
      })
      this.convertValuesToInnerFormat(this.model[this.name])
    },
    methods: {
      convertValuesToInnerFormat (v) {
        console.log('convertValuesToInnerFormat', v)
        if (this.isConverterLocked() === true) {
          this.unlockConverter()
          return
        }
        if (Array.isArray(v)) {
          let {treeIndex} = this.buildedTree
          let newValues = []
          const values = v.slice()
          // add all childs for expand tree
          values.forEach(id => {
            newValues = [
              id,
              ...newValues,
              ...treeIndex[id].childsIdArr
            ]
          })
          this.valuesModel.vals = newValues
        } else {
          console.error('Values isnt array')
        }
      },
      getLastSelectedParentId (keyId, treeIndex) {
        if (!treeIndex[keyId].parentId) {
          return keyId
        }
        let parent = treeIndex[treeIndex[keyId].parentId]
        if (parent.isAllSelected === true) {
          return this.getLastSelectedParentId(parent.id, treeIndex)
        }
        return keyId
      },
      convertInnerValueToOuterFormat () {
        this.lockConverter()
        const {treeIndex} = this.trees
        let newVals = []
        for (let keyId in treeIndex) {
          if (this.valuesModel.vals.indexOf(keyId) > -1) {
            if (treeIndex[keyId].isPartialSelect === false) {
              newVals.push(
                this.getLastSelectedParentId(keyId, treeIndex)
              )
            } else {
              newVals.push(keyId)
            }
          }
        }
        newVals = [...new Set(newVals)]
        this.model[this.name] = newVals
      },
      isConverterLocked () {
        return this._lockWatcher === true
      },
      lockConverter () {
        this._lockWatcher = true
      },
      unlockConverter () {
        this._lockWatcher = false
      },
      buildTreeChilds (childs = [], parent, opts = {}) {
        let {tKey, vKey, cKey} = opts
        let tmp = []
        childs.forEach(c => {
          const item = new ListItem()
          item.id = c[vKey]
          item.parentId = parent.id
          item.path = [
            ...parent.path,
            c[vKey]
          ]
          item.deep = item.path.length - 1
          item.name = this.optionTextFunc(c[tKey], item.deep, c)
          // console.log(cKey, c[cKey])
          if (Array.isArray(c[cKey])) {
            item.childs = this.buildTreeChilds(
              c[cKey],
              item,
              opts
            )
          }
          tmp.push(item)
        })
        return tmp
      },
      buildTreeRoot (tree, {pKey}) {
        const root = new ListItem()
        root.name = this.optionTextFunc('Все зоны', root.deep, null)
        tree.forEach(v => {
          root.id = v[pKey]
          root.path = [v[pKey]]
        })
        root.childs = tree
        return root
      },
      setChildsInTreeIdItemIndex (treeIndex) {
        for (let key in treeIndex) {
          for (let d = 0; d < treeIndex[key].deep; d++) {
            let parentId = treeIndex[key].path[d]
            // set value to parent
            treeIndex[parentId].childsIdArr.push(key)
          }
        }
        return treeIndex
      },
      buildTreeIdItemIndex (tree, indexedTree = {}) {
        tree.forEach((item, i) => {
          indexedTree[item.id] = tree[i]
          indexedTree = this.buildTreeIdItemIndex(tree[i].childs, indexedTree)
        })
        return indexedTree
      },
      buildTree (tree, opts = {}) {
        const t0 = performance.now()
        // parent->childs
        const root = this.buildTreeRoot(tree, opts)
        root.childs = this.buildTreeChilds(root.childs, root, opts)
        const nestedTree = [root]
        // tree index
        let treeIndex = this.buildTreeIdItemIndex(nestedTree)
        treeIndex = this.setChildsInTreeIdItemIndex(treeIndex)
        console.log('buildTree', performance.now() - t0, nestedTree)
        return {
          nestedTree,
          treeIndex
        }
      },
      setSelectionFlags (vals, treeIndex) {
        for (let keyId in treeIndex) {
          let existCounter = 0
          treeIndex[keyId].childsIdArr.forEach(id => {
            if (vals.indexOf(id) > -1) {
              existCounter++
            }
          })
          // partial
          if (existCounter > 0 && treeIndex[keyId].childsIdArr.length > existCounter) {
            treeIndex[keyId].isPartialSelect = true
          } else {
            treeIndex[keyId].isPartialSelect = false
          }
          // select all
          if (existCounter === treeIndex[keyId].childsIdArr.length) {
            treeIndex[keyId].isAllSelected = true
          } else {
            treeIndex[keyId].isAllSelected = false
          }
        }
        return treeIndex
      },
      redrawScroll () {
        setTimeout(() => {
          this.$refs.scroll && this.$refs.scroll.update()
        }, 0)
      },
      onExpand ($event) {
        this.redrawScroll()
      },
      onCollapse ($event) {
        this.redrawScroll()
      },
      change ($event) {
        this.$emit('change', $event)
        if (this.onChangeValidation) {
          this.validate()
        }
      },
      getElement () {
        return this.$refs.element
      },
      validate () {
        let msg = ''
        this.convertInnerValueToOuterFormat()

        if (!Array.isArray(this.model[this.name])) {
          msg = 'Свойство ' + this.name + ' не массив'
        }

        if (this.required && !msg && this.model[this.name].length === 0){
          msg = 'Необходимо выбрать минимум одно значение'
        }

        console.log(this.model)

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
